import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import util from '@/libs/util.js';
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  name: 'MaterialEdit',
  data: function data() {
    return {
      uploadUrl: process.env.VUE_APP_API,
      downUrl: process.env.VUE_APP_DOWNLOAD_URL,
      uploadHeaders: {
        Authorization: util.cookies.get('token')
      },
      fileList: [],
      accountList: [],
      defaultAccountId: null,
      title: '',
      form: {
        materialId: null,
        accountId: null,
        pushText: '',
        images: ''
      },
      rules: {
        pushText: [{
          required: true,
          message: '请输入推送文字',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    getAccountList: function getAccountList() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.GET_MATERIAL_ACCOUNT_LIST({});
            case 1:
              res = _context.v;
              _this.accountList = res.body;
              // 账号表仅一条数据，记录第一条账号ID，新增素材时默认使用
              _this.defaultAccountId = res.body && res.body.length > 0 ? res.body[0].id : null;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    handleAvatarSuccess: function handleAvatarSuccess(res, file) {
      this.fileList.push(file);
    },
    beforeAvatarUpload: function beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error('上传文件不能超过 10MB!');
      }
      return isLt2M;
    },
    handleRemove: function handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    setTitle: function setTitle(title) {
      this.title = title;
    },
    initData: function initData() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (_this2.$refs.form !== undefined) _this2.$refs.form.resetFields();
              _this2.form.materialId = null;
              _this2.form.pushText = null;
              _this2.form.images = null;
              _this2.fileList = [];
              // 账号表仅一条数据，新增素材默认取第一条账号
              _context2.n = 1;
              return _this2.getAccountList();
            case 1:
              _this2.form.accountId = _this2.defaultAccountId;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    setData: function setData(data) {
      var _this3 = this;
      if (this.$refs.form !== undefined) this.$refs.form.resetFields();
      this.form.materialId = data.materialId;
      this.form.accountId = data.accountId;
      this.form.pushText = data.pushText;
      this.form.images = data.images;
      // 回显已有附图：把 images(JSON字符串) 解析为 el-upload 的 fileList
      this.fileList = [];
      if (data.images) {
        try {
          var imgs = JSON.parse(data.images);
          this.fileList = imgs.map(function (img, index) {
            return {
              name: 'image' + index,
              url: _this3.downUrl + img.url,
              response: {
                body: img
              }
            };
          });
        } catch (e) {
          this.fileList = [];
        }
      }
    },
    updateApi: function updateApi() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return api.UPDATE_MATERIAL(_this4.form);
            case 1:
              _this4.$emit('initTableData');
              _this4.$message.success('操作成功');
              _this4.handleClose();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    saveApi: function saveApi() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.SAVE_MATERIAL(_this5.form);
            case 1:
              _this5.$emit('initTableData');
              _this5.$message.success('操作成功');
              _this5.handleClose();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    save: function save() {
      var _this6 = this;
      if (this.fileList.length > 0) {
        var files = [];
        this.fileList.forEach(function (file) {
          if (file.response) files.push(file.response.body);
        });
        this.form.images = JSON.stringify(files);
      }
      this.$refs.form.validate(function (valid) {
        if (valid) {
          if (_this6.form.materialId != null) {
            _this6.$confirm('此操作将永久修改该数据, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(function () {
              return _this6.updateApi();
            }).catch(function () {
              return _this6.$message({
                type: 'info',
                message: '已取消修改'
              });
            });
          } else {
            _this6.saveApi();
          }
        } else {
          return false;
        }
      });
    },
    handleClose: function handleClose(done) {
      this.$emit('close');
    }
  },
  created: function created() {
    this.getAccountList();
  }
};